import { useEffect,useState } from "react"
import { socket } from "./socket";
import { useSelector } from "react-redux";
import GamePage from "./GamePage";
import MainMenu from "./MainMenu";
import Loader from "./gaming_components/Loader/Loader";
import NavBar from "./components/Navbar";
import Toast from "./components/Toast/Toast";
import { setPlayerID,setSocketConnection } from "./redux/stores/GameStore";
import { useDispatch } from "react-redux";
import "./App.scss";
import PageLoader from "./components/PageLoader/PageLoader";
import Backdrop from "./components/Backdrop/Backdrop";
function App() {
  const dispatch = useDispatch();  
  const [ startScreen, setStartScreen ] = useState(true);
  const { gamePage, showLoader } = useSelector(state=>state.game)
  const [ connectedCount, setConnectedCount ] = useState(0);
  useEffect(()=>{
    setTimeout(()=>{
      setStartScreen(false);
    },1500) // Faster initial load - reduced from 2000ms to 1500ms
  },[])

  useEffect(()=>{    
    // Connect to socket
    if (!socket.connected) {
      console.log('Attempting to connect to socket...');
      socket.connect();
    }
    
    // Handle successful connection
    const handleConnect = () => {      
      console.log('Socket connected in App component, ID:', socket.id);
      dispatch(setPlayerID({socket_id: socket.id}));
      dispatch(setSocketConnection());
    };
    
    // Handle connection errors
    const handleConnectError = (error) => {
      console.error('Connection error in App:', error.message);
      // You could dispatch an error state here if needed
    };
    
    // Handle disconnection
    const handleDisconnect = (reason) => {
      console.warn('Socket disconnected in App:', reason);
    };
    
    // Handle users count
    const logUsers = (data) => {
      setConnectedCount(prevCount => prevCount = data);
    };
    
    // Register event listeners
    socket.on('connect', handleConnect);
    socket.on('connect_error', handleConnectError);
    socket.on('disconnect', handleDisconnect);
    socket.on('users count', logUsers);
    
    // Cleanup on unmount
    return () => {
      socket.off('connect', handleConnect);
      socket.off('connect_error', handleConnectError);
      socket.off('disconnect', handleDisconnect);
      socket.off("users count", logUsers);
      // Don't disconnect here - let it stay connected for the app lifetime
      // socket.disconnect();
    };
  },[dispatch, setConnectedCount]);
  return (
    <>
      { showLoader ? <Backdrop/> : null }
      <Toast />
      {/* Render Loader outside of relative containers to ensure full viewport coverage */}
      {showLoader ? <Loader/> : null}
      <div className="App">
      {startScreen ?         
      <PageLoader/>
      :
      <div className="app-content app-content--visible">
        <NavBar
        connected_count={connectedCount}
        ></NavBar>   
        {gamePage === false?<MainMenu/>:<GamePage/>}            
      </div>
      }
      </div>
    </>
  );
}

export default App;
